const MAX_FILE_NAME_LENGTH = 28
const MAX_EXTENSION_LENGTH = 10
const ELLIPSIS = "..."

/**
 * Shortens a long file name in the middle, keeping its start, its end and the extension, so files with the same
 * beginning stay distinguishable: "Screen Recording 2026-10-22 at 13.05.11.mov" → "Screen Recordi...3.05.11.mov".
 * Short enough that the size-limit toast always shows its text in full after the name.
 */
export const cutFileName = (fileName: string, maxLength = MAX_FILE_NAME_LENGTH) => {
  if (fileName.length <= maxLength) return fileName

  const dotIndex = fileName.lastIndexOf(".")
  const hasExtension = dotIndex > 0 && fileName.length - dotIndex <= MAX_EXTENSION_LENGTH
  const extension = hasExtension ? fileName.slice(dotIndex) : ""
  const name = fileName.slice(0, fileName.length - extension.length)
  const visibleLength = maxLength - extension.length - ELLIPSIS.length
  const endLength = Math.floor(visibleLength / 3)
  const startLength = visibleLength - endLength

  return `${name.slice(0, startLength)}${ELLIPSIS}${name.slice(-endLength)}${extension}`
}
